import { render, staticRenderFns } from "./documentInfo.vue?vue&type=template&id=4b02d465&scoped=true&"
import script from "./documentInfo.vue?vue&type=script&lang=js&"
export * from "./documentInfo.vue?vue&type=script&lang=js&"
import style0 from "./documentInfo.vue?vue&type=style&index=0&id=4b02d465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b02d465",
  null
  
)

export default component.exports